import React from 'react';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
var DEFAULT_POSITION = {
  bottom: 20,
  right: 20
};
export var SupportContactsWidgetRootWrapper = function SupportContactsWidgetRootWrapper(_ref) {
  var children = _ref.children,
    _ref$contactsPosition = _ref.contactsPosition,
    contactsPosition = _ref$contactsPosition === void 0 ? DEFAULT_POSITION : _ref$contactsPosition;
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    style: contactsPosition,
    children: children
  });
};